// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CommonLayout_wrapper__1P_EG"};